export default "__VITE_ASSET__CJiG7VgL__"